import React from 'react'
import Navbar from '../../layout/Navbar'
import "./About.css"

const Dashboard = () => {
  return (
        <div >
      <div id='about-page'>
      <Navbar />
      <div id='about-hero'>
        <h5>ABOUT US</h5>
        <h2>LET US TELL <span>WHO WE ARE</span></h2>
        <p id='about-text'>Vwrap is serving different brands to advertise and endorse
their values through our specialized IMC based solutions. We
also provide many disruptive Out-Of-Home (OOH) advertising
platforms & work efficiently on the fast paced digital media
channels to keep our clients always a step ahead.</p>
      </div>
    </div>
        
    </div>
  )
}

export default Dashboard
